import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-chutes',
  templateUrl: './chutes.component.html',
  styleUrls: ['./chutes.component.scss']
})
export class ChutesComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  selectedBase;
  bases = [];
  userIsSysAdmin = false;

  type = {
    name: 'All',
    value: 'All'
  };
  chutes = [];
  originalChutes = [];
  headings = [
    {
      label: 'Chute',
      key: 'style'
    },
    {
      label: 'Chute Number',
      key: 'name'
    },
    {
      label: 'Chute Type/Model',
      key: 'chuteType'
    },
    {
      label: 'Chute Size',
      key: 'chuteSize'
    },
    {
      label: 'Active',
      key: 'active'
    }
  ];
  settings = {
    label: 'New Chute',
    action: 'create',
    target: 'chutes',
    route: 'chutes'
  };

  constructor(private toast: ToastService) {}

  ngOnInit() {
    let type = window.sessionStorage.getItem('chutesType');
    if (type === 'Main' || type === 'Drogue' || type === 'Reserve') {
      this.type = {
        name: type,
        value: type
      };
    } else {
      this.type = {
        name: 'All',
        value: 'All'
      };
    }

    if (this.userInfo.role == 'sysadmin') {
      this.userIsSysAdmin = true;
    }

    axios
    .get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    })
    .then((response) => {
      this.bases = response.data;

      this.bases.forEach((base) => {
        base.name = base.text + ' | ' + base.baseCode;
        base.value = base.baseId;

        if (base.baseCode === this.userInfo.baseCode) {
          this.selectedBase = base;
          this.refreshChutes();
        }
      });
    })
    .catch((error) => {
      console.dir(error);
    });
  }

  selectHomeBase(selectedBase) {
    this.selectedBase = selectedBase;
    this.refreshChutes();
  }

  refreshChutes = async () => {
    this.loading = true;
    let baseCode = this.selectedBase.baseCode;
    this.userBase = this.userInfo.basecode;
    let mainChutes = await axios.get(
      environment.API_URL + '/chutemain?baseCode=' + baseCode,
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.chutes = mainChutes.data.value;

    // sort main chutes
    this.chutes = this.sort(this.chutes, 'main');
    this.chutes = this.reverseSort(this.chutes, 'inService');

    let getdrogueChutes = await axios.get(
      environment.API_URL + '/chutedrogue?baseCode=' + baseCode,
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    let drogueChutes = getdrogueChutes.data.value;

    // sort drogue chutes
    drogueChutes = this.sort(drogueChutes, 'drogue');
    drogueChutes = this.reverseSort(drogueChutes, 'inService');

    this.chutes = this.chutes.concat(drogueChutes);

    let getreserveChutes = await axios.get(
      environment.API_URL + '/chutereserve?baseCode=' + baseCode,
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    let reserveChutes = getreserveChutes.data.value;

    // sort reserve chutes
    reserveChutes = this.sort(reserveChutes, 'reserve');
    reserveChutes = this.reverseSort(reserveChutes, 'inService');

    this.chutes = this.chutes.concat(reserveChutes);

    this.chutes.forEach((chute) => {
      if (chute.main) {
        chute.style = 'Main';
        chute.name = chute.main;
      }
      if (chute.drogue) {
        chute.style = 'Drogue';
        chute.name = chute.drogue;
      }
      if (chute.reserve) {
        chute.style = 'Reserve';
        chute.name = chute.reserve;
      }
      chute.active = chute.inService ? 'Yes' : 'No';
    });

    // for filtering
    this.originalChutes = this.chutes;

    if (this.type.value === 'Drogue') {
      this.chutes = drogueChutes;
    }
    if (this.type.value === 'Reserve') {
      this.chutes = reserveChutes;
    }
    if (this.type.value === 'Main') {
      this.chutes = mainChutes.data.value;
    }

    this.loading = false;
  };

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  reverseSort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA > keyB) {
        return -1;
      }
      if (keyA < keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.chute);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDelete = (chute) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this parachute?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        chute: chute
      },
      active: true
    };
  };

  delete = (chute) => {
    let id = chute.href.slice(
      chute.href.lastIndexOf('/') + 1,
      chute.href.length
    );
    if (id.includes('base')) {
      id = id.slice(0, id.indexOf('?'));
    }
    axios
      .delete(
        environment.API_URL +
          '/chute' +
          chute.style.toLowerCase() +
          '/' +
          id +
          '/delete',
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Chute', 'success');
        this.refreshChutes();
      })
      .catch((error) => {
        if (error.response.data.detail !== null) {
          if (error.response.data.detail.startsWith('The DELETE statement conflicted with the REFERENCE constraint')) {
            this.toast.show('The Chute is used by one or more Incident Jumper records, and cannot be deleted', 'error');
          } else {
            this.toast.show('Unable to Delete Chute', 'error');
          }
        } else {          
          this.toast.show('Unable to Delete Chute', 'error');
        }
      });
  };

  selectType = (type) => {
    window.sessionStorage.setItem('chutesType', type.value);
    let filteredChutes = [];
    this.type = type;

    if (type.value === 'All') {
      this.chutes = this.originalChutes;
      return;
    }

    this.originalChutes.forEach((chute) => {
      if (chute.style === type.value) {
        filteredChutes.push(chute);
      }
    });

    this.chutes = filteredChutes;
  };
}
